import { Component, OnInit } from '@angular/core';
import { FilterInterface, ProductCategories } from '../../interfaces/filter.interface';
import { Store } from '@ngrx/store';
import { SelectProductCategories } from '../../store/actions/filter.actions';
import { Subscription } from 'rxjs';
import { SearchFilterService } from '../../services/search-filter.service';
import i18next from 'i18next';

@Component({
  selector: 'app-product-category',
  templateUrl: './product-category.component.html',
  styleUrls: ['./product-category.component.scss']
})
export class ProductCategoryComponent implements OnInit {
  productCategoriesSelected: ProductCategories = {};
  private subscriptions: Subscription = new Subscription();
  categories: ({ name: string; key: string })[] = [];


  constructor(private store: Store<{ filter: FilterInterface }>, private searchFilterService: SearchFilterService) {
  }

  ngOnInit(): void {
    this.store.select('filter').subscribe((data) => {
      this.productCategoriesSelected = { ...data.tags.productCategories };
    });
    this.setCategories();
    const resetFilter = this.searchFilterService.resetFilters$.subscribe((reset) => {
      if (reset) {
        console.log('category reset');
        this.productCategoriesSelected = {};
        this.store.dispatch(SelectProductCategories(this.productCategoriesSelected));
      }
    });
  }

  setCategories(): void {
    this.categories = [
      {
        key: 'Aufbewahren',
        name: i18next.t('product-category.store'),
      },
      {
        key: 'Backen & Kochen',
        name: i18next.t('product-category.cook'),
      },
      {
        key: 'Bar',
        name: i18next.t('product-category.bar'),
      },
      {
        key: 'Becher',
        name: i18next.t('product-category.cup'),
      },
      {
        key: 'Bestecksets',
        name: i18next.t('product-category.cutlery-sets'),
      },
      {
        key: 'Bier',
        name: i18next.t('product-category.beer'),
      },
      {
        key: 'Eyecatcher',
        name: i18next.t('product-category.eye-catcher'),
      },
      {
        key: 'Gabeln',
        name: i18next.t('product-category.forks'),
      },
      {
        key: 'Geschirrsets',
        name: i18next.t('product-category.tableware-sets'),
      },
      {
        key: 'Karaffen',
        name: i18next.t('product-category.carafes'),
      },
      {
        key: 'Kerzen',
        name: i18next.t('product-category.candles'),
      },
      {
        key: 'Kerzenhalter',
        name: i18next.t('product-category.candlestick'),
      },
      {
        key: 'La Boule',
        name: i18next.t('product-category.la-boule'),
      },
      {
        key: 'Leer-Kassetten',
        name: i18next.t('product-category.blank-cartridges'),
      },
      {
        key: 'Löffel',
        name: i18next.t('product-category.spoon'),
      },
      {
        key: 'Messer',
        name: i18next.t('product-category.knife'),
      },
      {
        key: 'Out of home',
        name: i18next.t('product-category.out-of-home'),
      }, {
        key: 'Platten',
        name: i18next.t('product-category.plates'),
      }, {
        key: 'Schüsseln & Schalen',
        name: i18next.t('product-category.bowls'),
      }, {
        key: 'Sekt',
        name: i18next.t('product-category.sparkling-wine'),
      }, {
        key: 'Servierbesteck',
        name: i18next.t('product-category.serving-cutlery'),
      }, {
        key: 'Servieren',
        name: i18next.t('product-category.serve'),
      }, {
        key: 'Servietten',
        name: i18next.t('product-category.napkins'),
      }, {
        key: 'sonstiges',
        name: i18next.t('product-category.miscellaneous'),
      }, {
        key: 'Spezialbesteck',
        name: i18next.t('product-category.special-cutlery'),
      }, {
        key: 'Tassen',
        name: i18next.t('product-category.cups'),
      }, {
        key: 'Teller',
        name: i18next.t('product-category.plate'),
      }, {
        key: 'Textil',
        name: i18next.t('product-category.textile'),
      }, {
        key: 'Vasen',
        name: i18next.t('product-category.vases'),
      }, {
        key: 'Wein',
        name: i18next.t('product-category.wine'),
      },
    ];
    this.categories.sort((a, b) => a.name > b.name ? 1 : a.name === b.name ? 0 : -1);
  }

  handleProductCategorySelected(productCategories: string): void {
    this.productCategoriesSelected[productCategories] = !this.productCategoriesSelected[productCategories];
    this.store.dispatch(SelectProductCategories(this.productCategoriesSelected));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
